export const errorStates = {
  AVAILABLE: 'AVAILABLE',
  UNAUTHORIZED: 'UNAUTHORIZED',
  NOT_FOUND: 'NOT_FOUND',
  UNAVAILABLE: 'UNAVAILABLE',
}

export function getErrorState(code) {
  if (code < 300) return errorStates.AVAILABLE
  if ([400, 401, 403].includes(code)) return errorStates.UNAUTHORIZED
  if (code === 404) return errorStates.NOT_FOUND
  return errorStates.UNAVAILABLE
}
